import { api } from "@/api";
import { AxiosResponse } from "axios";
import { PayloadNotificationListType } from "../types";

class API {
  static getIsNotification(role: string): Promise<AxiosResponse> {
    const prefix =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/notification"
        : "/notification/it4cio";
    return api.get(`${prefix}/verify`);
  }
  static getNotificationWasSeen(params: number): Promise<AxiosResponse> {
    return api.get(`/notification/update/${params}`);
  }
  static getNotificationList(
    role: string,
    payload?: PayloadNotificationListType
  ): Promise<AxiosResponse> {
    // FOUR_NETWORK e MARKETING usam endpoint /by-user
    if (role === "FOUR_NETWORK" || role === "MARKETING") {
      return api.get("/notification/by-user");
    }
    // Outros usuários usam endpoint com paginação
    return api.get("/notification/it4cio", { params: payload });
  }
  static putNotificationConfigure(
    role: string,
    payload: any
  ): Promise<AxiosResponse> {
    // FOUR_NETWORK e MARKETING usam /configure
    if (role === "FOUR_NETWORK" || role === "MARKETING") {
      return api.put("/notification/configure", payload);
    }
    // Outros usuários usam /configuration
    return api.put("/notification/it4cio/configuration", payload);
  }
  static getNotificationConfig(role: string): Promise<AxiosResponse> {
    // FOUR_NETWORK e MARKETING usam /configurations
    if (role === "FOUR_NETWORK" || role === "MARKETING") {
      return api.get("/notification/configurations");
    }
    // Outros usuários usam /configuration
    return api.get("/notification/it4cio/configuration");
  }
  static getIsMessageNotification(): Promise<AxiosResponse> {
    return api.get("/notification/message-verify");
  }
  static patchNotificationRead(
    role: string,
    payload: number
  ): Promise<AxiosResponse> {
    if (role === "FOUR_NETWORK" || role === "MARKETING") {
      return api.get(`/notification/update/${payload}`);
    } else {
      return api.patch(`/notification/it4cio/${payload}/read`);
    }
  }
  static patchNotificationUnread(
    role: string,
    payload: number
  ): Promise<AxiosResponse> {
    const prefix =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/notification"
        : "/notification/it4cio";
    return api.patch(`${prefix}/${payload}/not-read`);
  }
  static deleteNotification(
    role: string,
    payload: number
  ): Promise<AxiosResponse> {
    const prefix =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/notification"
        : "/notification/it4cio";
    return api.delete(`${prefix}/${payload}`);
  }
  static patchNotificationAllRead(role: string): Promise<AxiosResponse> {
    const prefix =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/notification"
        : "/notification/it4cio";
    return api.patch(`${prefix}/all/read`);
  }
}

export default API;
